import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import ClockOutSuccessModal from "./ClockOutSuccessModal";
import { DaySummary } from "components/CheckInCheckOut/types";
import CustomButton from "components/common/Button";

// Example usage of ClockOutSuccessModal component
function ClockOutSuccessModalExample() {
  const [open, setOpen] = useState(false);
  const [searchParams] = useSearchParams();

  // Get dynamic data from URL parameters
  const daySummary: DaySummary = {
    totalHours: searchParams.get("totalHours") || "10 hr 2 min",
    timeWorked: searchParams.get("timeWorked") || "9 hr 4 min",
    breaks: searchParams.get("breaks") || "1 hr 12 min",
    nursing: searchParams.get("nursing") || "45 min",
  };

  // Auto-open modal when component mounts if URL params are present
  useEffect(() => {
    if (searchParams.toString()) {
      setOpen(true);
    }
  }, [searchParams]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleViewTimesheet = () => {
    // Handle view timesheet logic here
    // Navigate to timesheet page or open timesheet modal
    setOpen(false);
  };

  return (
    <div>
      <div className="mb-2">
        <h3 className="heading-h3-semibold color-text-heading-primary mb-1">ClockOut Success Modal Example</h3>
        <p className="para-body-m-regular color-text-body-secondary mb-2">
          This modal can be used with URL parameters to show dynamic data:
        </p>
        <div className="p-05" style={{ backgroundColor: "var(--color-primitives-neutral-50)", borderRadius: "0.5rem" }}>
          <p className="para-body-s-regular color-text-body-secondary">
            <strong>Example URL:</strong>
            <br />
            /main/clock-out-success-example?totalHours=8%20hr%2030%20min&timeWorked=7%20hr%2015%20min&breaks=1%20hr%2015%20min&nursing=30%20min
          </p>
        </div>
      </div>

      <CustomButton label="Show Success Modal" onClick={handleOpen} variant="contained" color="primary" />

      <ClockOutSuccessModal
        open={open}
        onClose={handleClose}
        onViewTimesheet={handleViewTimesheet}
        daySummary={daySummary}
      />
    </div>
  );
}

export default ClockOutSuccessModalExample;
